import { Card, CardContent } from '@/components/shadcn/card.tsx';
import type { ReactNode } from 'react';

interface CardWrapperProps {
  children: ReactNode;
}

const CardWrapper = ({ children }: CardWrapperProps) => {
  return (
    <Card className='shadow-none p-0'>
      <CardContent className='p-2'>{children}</CardContent>
    </Card>
  );
};

export default CardWrapper;
